import { format } from 'date-fns';
import { OptionsDropdown } from 'shared/ui/OptionsDropdown';
import { ModelsType } from 'entities/CustomModel/types';
import { Column } from 'shared/ui/tables/_common/types';
import { TableTranslationLabel } from 'shared/ui/tables/_common/ui/TableTranslationLabel';

export const ModelsTableColumns: Array<
	Column<
		ModelsType & {
			removeModel: (model: ModelsType) => void;
			navigateToTrain: (model: ModelsType) => void;
			navigateToSettings: (model: ModelsType) => void;
		}
	>
> = [
	{
		field: 'name',
		commonCellSettings: {
			style: {
				minWidth: '300px',
				maxWidth: '300px',
			},
		},
		headerCellSettings: {
			renderCell: () => <TableTranslationLabel label="name" />,
		},
		bodyCellSettings: {
			renderCell: (partner) => partner?.name || '-',
		},
	},
	{
		field: 'modelBuildMode',
		commonCellSettings: {
			style: {
				minWidth: '150px',
				maxWidth: '150px',
			},
		},
		headerCellSettings: {
			renderCell: () => <TableTranslationLabel label="model_type" />,
		},
		bodyCellSettings: {
			renderCell: (model) =>
				model?.modelBuildMode ? (
					<TableTranslationLabel path={`custom_model.model_types.${model?.modelBuildMode}`} />
				) : (
					'-'
				),
		},
	},
	{
		field: 'totalFiles',
		commonCellSettings: {
			style: {
				minWidth: '150px',
				maxWidth: '250px',
			},
		},
		headerCellSettings: {
			renderCell: () => <TableTranslationLabel label="total_file_qty" />,
		},
		bodyCellSettings: {
			prepareField: (model) => (model?.totalFiles ? `${model?.totalFiles}` : '-'),
		},
	},
	{
		field: 'status',
		commonCellSettings: {
			style: {
				minWidth: '150px',
				maxWidth: '250px',
			},
		},
		headerCellSettings: {
			renderCell: () => <TableTranslationLabel label="status" />,
		},
		bodyCellSettings: {
			renderCell: (model) =>
				model?.status ? <TableTranslationLabel label={`model_status.${model?.status}`} /> : '-',
		},
	},
	{
		field: 'createdDate',
		commonCellSettings: {
			style: {
				minWidth: '150px',
				maxWidth: '250px',
			},
		},
		headerCellSettings: {
			renderCell: () => <TableTranslationLabel label="create_date" />,
		},
		bodyCellSettings: {
			prepareField: (model) =>
				model?.createdAt ? format(new Date(model?.createdAt), 'dd/MM/yyyy') : '-',
		},
	},
	{
		field: 'lastChanges',
		commonCellSettings: {
			style: {
				minWidth: '150px',
				maxWidth: '250px',
			},
		},
		headerCellSettings: {
			renderCell: () => <TableTranslationLabel label="last_changes" />,
		},
		bodyCellSettings: {
			prepareField: (model) =>
				model?.updatedAt ? format(new Date(model?.updatedAt), 'dd/MM/yyyy') : '-',
		},
	},
	{
		field: 'options',
		commonCellSettings: {
			style: {
				minWidth: '100px',
				maxWidth: '100px',
			},
		},
		bodyCellSettings: {
			renderCell: (model) => {
				return (
					<OptionsDropdown
						iconId={'more_horizontal'}
						optionList={[
							{
								label: 'shared_texts.table_dropdown.settings',
								value: 'Settings',
								action: () => {
									model?.navigateToSettings && model.navigateToSettings(model);
								},
							},
							{
								label: 'shared_texts.table_dropdown.train',
								value: 'Train',
								action: () => {
									model?.navigateToTrain && model.navigateToTrain(model);
								},
							},
							{
								label: 'shared_texts.remove',
								value: 'Remove model',
								action: () => {
									model?.removeModel && model.removeModel(model);
								},
							},
						]}
					/>
				);
			},
		},
	},
];
